module.exports = __webpack_public_path__ + "static/media/loader.b1383798.gif";